import { FontWeight } from '@pasteltech/theme-provider'
import { memo, useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'
import { PagePaths } from '../../constants'
import { ScreenQuery } from '../../utilities'
import { CheckMoreButton } from '../button'
import { Case, CaseCard, CaseDetailOverlay } from '../case'

const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.container.high};
  background-image: url('/images/home-page-showcase-preview-background.png');
  background-position: right bottom;
  background-repeat: no-repeat;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  padding: ${({ theme }) => theme.sizes.spacings.xxxxxl}px 0px;
  gap: ${({ theme }) => theme.sizes.spacings.xxxxl}px;
  width: 80%;
  margin: 0 auto;
`
const CaseList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${({ theme }) => theme.sizes.spacings.xxxxl}px;
  ${ScreenQuery.tablet} {
    grid-template-columns: 1fr;
  }
  ${ScreenQuery.mobile} {
    grid-template-columns: 1fr;
  }
`
const Title = styled.div`
  text-align: center;
  align-self: stretch;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.primary.mainContrast};
  font-size: ${({ theme }) => theme.sizes.fontSize.heading1}px;
  font-weight: ${FontWeight.bold};
`

type Props = {
  data: Case[]
  title: string
}
export const CasePreview = memo(({ data, title }: Props) => {
  const [selectedPost, setSelectedPost] = useState<Case | null>(null)
  const cards = useMemo(
    () =>
      data.map((post) => ({
        post,
        onClick: () => setSelectedPost(post),
      })),
    [data],
  )
  const handleOverlayClose = useCallback(() => {
    setSelectedPost(null)
  }, [])
  return (
    <Background>
      <Container>
        <Title>{title}</Title>
        <CaseList>
          {cards.map(({ post, onClick }) => (
            <CaseCard key={post.id} post={post} onClick={onClick} />
          ))}
        </CaseList>
        <CheckMoreButton to={PagePaths.showcase} />
      </Container>
      {selectedPost && (
        <CaseDetailOverlay onClose={handleOverlayClose} post={selectedPost} />
      )}
    </Background>
  )
})

CasePreview.displayName = 'CasePreview'
